var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.show_link_tag ? 'a' : _vm.non_link_tag,_vm._b({tag:"component",on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.link_data,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }